export default __webpack_public_path__ + "static/media/button-left-decoration-border.98eafe60.svg";